import { Route, Routes } from "react-router-dom";
import UploadFile from "../Pages/UploadFile";
import UploadFileLoading from "../Pages/UploadFileLoading";
import Cart from "../Pages/Cart";
import EditOrder from "../Pages/EditOrder";
import Quotes from "../Pages/Quotes";
import Order from "../Pages/Order";
import Account from "../Pages/Account";
import CreateTicket from "../Pages/CreateTicket";
import Ticket from "../Pages/Ticket";
import DetailsTicket from "../Pages/DetailsTicket";
import Factors from "../Pages/Factors";
import PrintFactor from "../Pages/PrintFactor";
import Notification from "../Pages/Notification";
import PaymentStatus from "../Pages/PaymentStatus";
import UserInfo from "../Pages/UserInfo";
import LegalInformation from "../Pages/LegalInformation";
import LegalInformationCreate from "../Pages/LegalInformationCreate";
import Addresses from "../Pages/Addresses";
import CreateAddress from "../Pages/CreateAddress";
import UserProfileEdit from "../Pages/UserProfileEdit";
import ChangePassword from "../Pages/ChangePassword";
import EditAddress from "../Pages/EditAddress";
import EditLegalInformationCreate from "../Pages/EditLegalInformationCreate";

const Authenticated = () => {

    return (
        <Routes>
            <Route path="/" element={<UploadFile />} />
            <Route path="/UploadFileLoading" element={<UploadFileLoading />} />
            <Route path="/editOrder/:id" element={<EditOrder />} />
            <Route path="/DetailOrder/:id" element={<EditOrder />} />
            <Route path="/Quotes" element={<Quotes />} />
            <Route path="/Order" element={<Order />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/account" element={<Account />}>
                <Route path="/account" element={<UserInfo />} />
                <Route path="edit" element={<UserProfileEdit />} />
                <Route path="legal-information" element={<LegalInformation />} />
                <Route path="legal-information/create" element={<LegalInformationCreate />} />
                <Route path="legal-information/edit/:id" element={<EditLegalInformationCreate />} />
                <Route path="addresses" element={<Addresses />} />
                <Route path="addresses/create" element={<CreateAddress />} />
                <Route path="address/:id" element={<EditAddress />} />
                <Route path="change-password" element={<ChangePassword />} />
            </Route>
            <Route path="/Factors/:id" element={<Factors />} />
            <Route path="/PrintFactor/:id" element={<PrintFactor />} />
            <Route path="/CreateTicket" element={<CreateTicket />} />
            <Route path="/DetailsTicket/:id" element={<DetailsTicket />} />
            <Route path="/Notification" element={<Notification />} />
            <Route path="/Ticket" element={<Ticket />} />
            <Route path="/paymentStatus" element={<PaymentStatus />} />
            <Route path="*" element={<UploadFile />} />
        </Routes>

    )

}

export default Authenticated;